import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge, validators } from 'tailwind-merge';

/**
 * `fs-*` is this app's type scale (see index.css). Registered in twMerge's
 * font-size group so `fs-12 fs-13` collapses to the later one, and so does
 * `text-sm fs-13` — otherwise a caller's size override would depend on CSS
 * source order.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ fs: [validators.isNumber] }],
    },
  },
});

/**
 * Conditional classes, with later Tailwind utilities beating earlier ones.
 *
 * Plain `clsx` would emit `px-3 px-6` and let CSS source order decide, which
 * makes a component's `className` override unreliable. twMerge resolves the
 * conflict by group, so a caller's `px-6` always wins.
 *
 * The token utilities (bg-surface, text-ink, …) are not in twMerge's built-in
 * class map, but it groups by the utility prefix, so `bg-surface bg-accent-tint`
 * still collapses correctly without extra configuration.
 */
export function cx(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
